import { ArchiveDuration } from "us.collection.admin/components/ClosureCodes/Constants";

/**
 * Add new closure code request object
 * @param this 
 * @returns 
 */
export function AddClosureCode(this: any) {
  return {
    id: -1,
    name: this.name,
    displayName: this.displayName,
    description: this.description,
    archiveDuration: this.archiveDuration,
    archiveDurationPeriod: ArchiveDuration.MONTHS,
    deletionDuration: this.deletionDuration,
    deletionDurationPeriod: ArchiveDuration.MONTHS,
    isStartFromCaseClosedDate: this.isStartFromCaseClosedDate,
    badDebtRecord: this.badDebtRecord,
  };
}

/**
 * Update closure code request object
 * @param this 
 * @returns 
 */
export function UpdateClosureCode(this: any) {
  return {
    id: this.id,
    name: this.name,
    displayName: this.displayName,
    description: this.description,
    archiveDuration: this.archiveDuration,
    archiveDurationPeriod: ArchiveDuration.MONTHS,
    deletionDuration: this.deletionDuration,
    deletionDurationPeriod: ArchiveDuration.MONTHS,
    isStartFromCaseClosedDate: this.isStartFromCaseClosedDate,
    badDebtRecord: this.badDebtRecord,
  };
}
